<template>
  <div
    v-if="updateList.length > 0"
  >
    <!-- <a 
      class="update-header">
      {{ updateName }}
    </a> -->

    <!-- <transition-group name="list">
    </transition-group> -->
    <calendar-bell-popup-entry
      v-for="entry in getEntriesToShow"
      :key="entry.id"
      :entry="entry"
      :last-entry="entry.id === updateList[updateList.length - 1].id"
      @delete-entry="deleteEntry"
    />

    <!-- <a 
      v-if="!showAll && updateList.length > 1 && updateName != 'Today'"
      class="show-all"
      @click.prevent="clickShowAll()"
    >
      {{ $t('showAll')+ "(" + (updateList.length - 1) + ")" }}
    </a>
    <a 
      v-if="showAll && updateList.length > 1 && updateName != 'Today'"
      class="show-all"
      @click.prevent="clickShowAll()"
    >
      {{ $t('showLess') }}
    </a> -->
  </div>
</template>

<script>

import CalendarBellPopupEntry from './CalendarBellPopupEntry.vue'
import ParseFunctions from '@/components/ParseFunctions'
import EventBus from '@/EventBus'
export default {
  name: 'CalendarBellPopupByDate',

  components: {
    CalendarBellPopupEntry
  },
  
  mixins:[ParseFunctions],
  
  props: {
    updateListProp: {
      type: Array,
      default: () => [],
    },
    // updateName: String,
  },
  
  data() {
    return {
      showAll: false,
      updateList : [],
    }
  },

  computed: {
    getEntriesToShow() {
      return this.updateList
      // if (this.showAll || this.updateName === 'Today') {
      //   return this.updateList
      // } else {
      //   return this.updateList.slice(0,1)
      // }
    },
  },
  
  watch: {
    updateListProp: function() {
      this.overwriteUpdateList()
    },
  },
  
  mounted() {
    this.overwriteUpdateList()

  },
  methods: {
    overwriteUpdateList() {
      this.updateList = this.updateListProp
    },
    async deleteEntry(idx) {
      let res = await this.deleteNotification(idx)
      if (res.status === 'ok') {
        this.updateList = this.updateList.filter(x => x.id !== idx)
      } else {
        EventBus.$emit('new-info-bar-msg',{msg:'Error',error:true})
      }

    },
    clickShowAll() {
      this.showAll = !this.showAll
    }
  },
}
</script>

<style scoped lang="scss">

.modal-wrapper {
  z-index: 5;
  border: 1px solid #ECEFF2;
  background-color: white;
  width: 300px;
  margin-top: 70px;
  position: absolute;
  height: 90%;
  align-self: flex-end;

  .updates-header {
    font-family: $bold;
    font-size: 20px;
    line-height: 25px;
    // margin-bottom: 25px
  }

  .update-header {
    font-family: $bold;
    color: black;
    font-size: 16px;
    line-height: 16px;
    width: 100%;
  }

  .show-all {
    cursor: pointer;
    display: block;
    height: 20px;
    color: $blue;
    font-family: $bold;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0.2px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 25px;
    margin-top: 5px;
    transition: color 0.15s ease-in-out;
    &:hover {
      color: $dark-blue;
    }
  }
}
</style>
